module.exports = __webpack_public_path__ + "static/img/gxgTop.3fd04a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxgTop.png
// module id = jD1c
// module chunks = 2